/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');
import '@fortawesome/fontawesome-free/css/all.min.css';

/**
 * Importing additional js dependencies
 */

require('toastr');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// require('./components/Customer/EditCustomer');
require('./components/TipOffs/TipOffPricing');
require('./components/ServiceProvider/CreateServiceProvider');
require('./components/ServiceProvider/PriceTables/ProviderPrices');
require('./components/ServiceProvider/TeamMembers/TeamMembers');
require('./components/ServiceProvider/ServiceProviderCustomers');
require('./components/Jobs/JobCustomerDropdowns');
require('./components/Jobs/JobDetailsDropdowns');
require('./components/Jobs/JobMedia');
require('./components/Jobs/JobForm');
require('./components/Customer/PriceTables/CustomerPrices');
require('./components/JobSource/JobSources');
require('./components/Jobs/JobsCalendar/JobCalendar');
require('./components/Customer/Jobs/CustomerJobs');
require('./components/Customer/Jobs/MissingPOJobs');
require('./components/Jobs/JobsTable/JobsTable');
require('./components/Jobs/dtn/EditWasteBag');
require('./components/Jobs/dtn/EditGardening');
require('./components/Jobs/dtn/EditVoid');
require('./components/Jobs/dtn/EditTyreCollection');
require('./components/Jobs/dtn/EditVolumeJobs');
require('./components/Jobs/dtn/SkipHireForm');
require('./components/ServiceProvider/TeamMembers/OrderJobs/MembersJobsList');
require('./components/ServiceProvider/dtn/CreateProviderJobDtn');
require('./components/ServiceProvider/WasteTipping/EditWasteTipping');

require('./components/Reports/MemberReports');
require('./components/Reports/ProvidersReports');
require('./components/Invoices/CustomerInvoices');
require('./components/Reports/JobsReport');
require('./components/CustomerContact/SelectDepartment');
require('./components/Invoices/SorSpreadsheets/SorSpreadsheets');
require('./components/Jobs/ReallocateJob');
require('./components/ServiceProvider/TipOffs');
require('./components/Invoices/InvoiceGroups/CreateInvoiceGroup');
require('./components/Customer/Recycle/RecycleFilter');
require('./components/Invoices/GroupedInvoices');
require('./components/Jobs/recycle/RecycleForm');
require('./components/WasteTipping/WasteTippingFilter');
require('./components/Settings/GlobalCustomerPricing');
require('./components/Settings/InvoiceConfiguration');
require('./components/Customer/RequestPoForm');
require('./components/User/Coverage');
require('./components/User/Operatives');
require('./components/Testing/TestingForm');
require('./components/Testing/TestingLogin');
require('./components/Testing/TestingInvoices');
require('./components/Testing/TestingCreateJob');
require('./components/Invoices/ReviewInvoices');

